import styled from '@emotion/styled';
import { Text, tokens, Button, Alert, Stack } from '@hotjar/hotsauce';

export const Content = styled.div<{ paddingRight: string | undefined }>`
  flex: 1;
  min-width: 1px;
  padding-right: ${tokens.spacer.x4};

  @media ${tokens.getMedia({ minWidth: 'l' })} {
    padding-right: ${({ paddingRight = '100px' }) => paddingRight};
  }

  @media ${tokens.getMedia({ minWidth: 'xl' })} {
    padding-right: ${({ paddingRight = '170px' }) => paddingRight};
  }
`;

export const Sidebar = styled(Stack)`
  @media ${tokens.getMedia({ minWidth: 'l' })} {
    width: 370px;
    position: sticky;
    top: 0px;

    img {
      padding-top: 80px;
    }
  }
`;

export const Heading = styled(Text)`
  ${tokens.text('header4')}
  margin-bottom: ${tokens.spacer.x4};
`;

export const CancelButton = styled(Button)`
  /* a little hack to compensate for the padding that is added by the Button component */
  margin-top: -${tokens.spacer.x2};
  align-self: flex-start;
`;

export const OnTrialAlert = styled(Alert)`
  white-space: pre-line;
`;
